import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { vodAdapterLite } from 'shared/utils/adapters/vod-lite';

import { normalizeVideo } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEO.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export function getPublic(channelId, videoId) {

  return function (dispatch) {
    const params = { channelId, videoId };
    dispatch(START(params));

    const promise = vodAdapterLite.listItems.getPublic(channelId, videoId);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeVideo(response.data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.video.get' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/server/actions/channel/video/get.js